import {
  SizeList,
  SizeListTitle,
  SizesListWrapper,
  SizesWrapper,
} from "./Sizes.styled";
import { SizeButton } from "./SizeButton";
import classNames from "classnames";

type SizeItem = {
  id: string;
  label: string;
  value: string;
  selected: boolean;
};

export function GroupedSizesView({
  mappedSizes,
  onSelect,
  wrapperRef,
  groupRefCallback,
}: {
  mappedSizes: [string, SizeItem[]][];
  onSelect: (value: string) => void;
  wrapperRef?: React.RefObject<HTMLDivElement>;
  groupRefCallback?: (title: string, el: Element | null) => void;
}): JSX.Element {
  return (
    <SizesListWrapper ref={wrapperRef as any}>
      {mappedSizes.map(([groupTitle, sizes]) => (
        <SizeList
          key={groupTitle}
          ref={(el) => groupRefCallback?.(groupTitle, el)}
        >
          <SizeListTitle>{groupTitle}</SizeListTitle>
          <SizesWrapper
            className={classNames({
              ["xlarge"]: sizes.some(({ label }) => label.length >= 7),
              ["large"]: sizes.some(
                ({ label }) => label.length >= 3 && label.length < 7
              ),
              ["small"]: sizes.every(({ label }) => label.length < 3),
            })}
          >
            {sizes.map(({ id, label, value, selected }) => (
              <SizeButton
                key={id}
                refine={onSelect}
                value={value}
                label={label}
                active={selected}
              />
            ))}
          </SizesWrapper>
        </SizeList>
      ))}
    </SizesListWrapper>
  );
}
